import { createContext, useContext } from 'react';

import type { AppRouter } from '@repo/trpc-router';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

export type TrpcProxy = TRPCOptionsProxy<AppRouter>;

const TrpcContext = createContext<TrpcProxy | null>(null);

export const useTrpc = (): TrpcProxy => {
    const trpc = useContext(TrpcContext);
    if (!trpc) {
        throw new Error('useTrpc must be used within TrpcProvider');
    }
    return trpc;
};

interface TrpcProviderProps {
    client: TrpcProxy;
    children: React.ReactNode;
}

export const TrpcProvider = ({ client, children }: TrpcProviderProps) => {
    return <TrpcContext.Provider value={client}>{children}</TrpcContext.Provider>;
};
